import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/app/(main)/article/TermsAndConditions/page.tsx");
